import { useEffect, useState } from 'react';

import { ClaimPanelData, ClaimPanelDataResponse } from '@/api/types/claimPanel';

import { SESSION_STORAGE_DATA_ITEM_NAME } from '../App';
import constate from 'constate';

function useLogin() {
  const [loginError, setLoginError] = useState(false);
  const [isLoggingIn, setIsLoggingIn] = useState(false);
  const [data, setData] = useState<ClaimPanelData | null>(
    sessionStorage.getItem(SESSION_STORAGE_DATA_ITEM_NAME)
      ? JSON.parse(sessionStorage.getItem(SESSION_STORAGE_DATA_ITEM_NAME) || '')
      : null
  );

  useEffect(() => {
    if (data) {
      setIsLoggingIn(true);
    }
  }, [data]);

  const handleLogin = (data: ClaimPanelDataResponse) => {
    const {
      user_data,
      case_info,
      defendant_info,
      case_statuses,
      product_id,
      service_id,
    } = data;

    const parsedData = {
      userData: {
        name: user_data?.name,
        caseID: user_data?.case_id,
        phoneNumber: user_data?.phone_number,
        email: user_data?.email,
      },
      caseInfo: {
        courtOfFirstInstance: case_info.court_of_first_instance,
        courtOfFirstInstanceSignature:
          case_info.court_of_first_instance_signature,
        courtOfSecondInstance: case_info.court_of_second_instance,
        courtOfSecondInstanceSignature:
          case_info.court_of_second_instance_signature,
      },
      loginTime: new Date().getTime(),
      defendantInfo: defendant_info,
      caseStatuses: case_statuses,
      productId: product_id,
      serviceId: service_id,
    };

    sessionStorage.setItem(
      SESSION_STORAGE_DATA_ITEM_NAME,
      JSON.stringify(parsedData)
    );
    setIsLoggingIn(true);
    setData(parsedData);
  };

  const handleLogout = () => {
    setIsLoggingIn(false);
    setTimeout(() => {
      sessionStorage.removeItem(SESSION_STORAGE_DATA_ITEM_NAME);
      setData(null);
    }, 1000);
  };

  return {
    data,
    loginError,
    setLoginError,
    handleLogin,
    handleLogout,
    isLoggingIn,
  };
}

export const [LoginProvider, useLoginContext] = constate(useLogin);
